export const LS_AUTH = 'ti:auth';
export const LS_AUTHTYPE = 'ti:authtype';
export const LS_AUTHID = 'ti:authid';
export const LS_AUTHINFO = 'ti:authinfo';
export const LS_SEARCH_PARAMS = 'ti:searchparams';
export const LS_AUTHCOMPANY = 'ti:authcomp'; //tenant

// TODO: polyfill
/**
 * Verifica se il localStorage è disponibile e scrivibile.
 * Utile per gestire casi di navigazione in incognito restrittiva o disabilitazione manuale.
 */
export const isStorageAvailable = () => {
  //return false;
  try {
    const testKey = '__storage_test__';
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

// Se il localStorage non è disponibile, usiamo un oggetto vuoto per evitare crash
// Ma l'applicazione dovrebbe comunque mostrare il fallback UI all'avvio.
const __storage = isStorageAvailable()
  ? window.localStorage
  : {
      setItem: () => {},
      getItem: () => null,
      removeItem: () => {},
      clear: () => {},
    };

export const setLocalStorage = (key, value) => {
  __storage.setItem(key, value);
};
export const getLocalStorage = (key) => __storage.getItem(key);

export const removeFromLocalStorage = (key) => {
  __storage.removeItem(key);
};
export const clearLocalStorage = () => {
  __storage.clear();
};

/**
 * Pulisce tutti i dati relativi all'autenticazione e alla sessione utente.
 */
export const clearAuthStorage = () => {
  removeFromLocalStorage(LS_AUTH);
  removeFromLocalStorage(LS_AUTHTYPE);
  removeFromLocalStorage(LS_AUTHID);
  removeFromLocalStorage(LS_AUTHINFO);
  removeFromLocalStorage(LS_AUTHCOMPANY);
  removeFromLocalStorage(LS_SEARCH_PARAMS);
};
